module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_02_770_280_zh-hant-d33278070a1a56b6535a9487cd7e3a01.jpg";